<div class="business-contract-component">
  <mat-card appearance="outlined">
    @if (application.ApplicationType==='BusinessOverdraft') {
      <mat-card>
        <h3 class="header">Contract Details</h3>
        <business-overdraft-quote
          [application]="application"
          [data]="data">
        </business-overdraft-quote>
      </mat-card>
    }
    <div class="break"></div>
    <mat-card>
      <asset-notes
        [isAssetUpdated]="isAssetUpdated"
        [getApplicationAuditLogsFn]="getApplicationAuditLogsFn"
        [getNotesByApplicationIdFn]="getNotesByApplicationIdFn"
        [createApplicationNoteFn]="createApplicationNoteFn"
        [removeApplicationNoteByNoteIdFn]="removeApplicationNoteByNoteIdFn"
      ></asset-notes>
    </mat-card>
  </mat-card>
</div>
